import { toastr } from 'react-redux-toastr';
import * as Service from '../../server/RestClients';

export const GET_IMAGE_LOADING = 'GET_IMAGE_LOADING';
export const GET_IMAGE_SUCCESS = 'GET_IMAGE_SUCCESS';
export const GET_IMAGE_FAILURE = 'GET_IMAGE_FAILURE';

export const fetchImage = (config, uuid, flags) => async (dispatch) => {
  dispatch({
    type: GET_IMAGE_LOADING,
  });
  try {
    const response = await Service.getSample(config, uuid, flags);
    dispatch({
      type: GET_IMAGE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_IMAGE_FAILURE,
      payload: e,
    });
    toastr.error('Failed to fetch image');
  }
};
